import { useState, useEffect } from 'react';
import { getOSINTCounts, OSINTCountsResponse } from '../api/countService';

const useOSINTCounts = () => {
  const [counts, setCounts] = useState<OSINTCountsResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const data = await getOSINTCounts();
        setCounts(data);
      } catch (err) {
        setError('Error al obtener los conteos de OSINT');
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, []);

  return { counts, loading, error };
};

export default useOSINTCounts;
